import { render, staticRenderFns } from "./CategoryBanner.vue?vue&type=template&id=2acf8112&scoped=true&"
import script from "./CategoryBanner.vue?vue&type=script&lang=js&"
export * from "./CategoryBanner.vue?vue&type=script&lang=js&"
import style0 from "./CategoryBanner.vue?vue&type=style&index=0&id=2acf8112&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2acf8112",
  null
  
)

export default component.exports